export default "__VITE_ASSET__BmcO5EmG__"